<template>
    <div id="filters" class="filters">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

            <b-form class="filters">
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Property Types
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="property_types"
                                v-model="criteria_breadcrumbs"
                                name="property_types"
                                :options="property_types"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Neighborhoods
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview limit">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="neighborhoods"
                                v-model="criteria_breadcrumbs"
                                name="neighborhoods"
                                :options="neighborhoods"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview mb-1">
                    <a href="#" class="nav-link">
                        <p>
                            Price Range
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li>
                            <b-form-input
                                @change="addPriceToCriteria()"
                                id="range-1"
                                name="price_ranges"
                                v-model="price_range"
                                type="range" step="50000"
                                min="0"
                                max="1000000">
                            </b-form-input>
                            <div class="mt-2"> Up to {{ parseFloat(price_range) | toCurrency }}</div>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Home Type
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="home-types"
                                v-model="criteria_breadcrumbs"
                                name="home-types"
                                :options="styles"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Bedrooms
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="bedrooms"
                                v-model="criteria_breadcrumbs"
                                name="bedrooms"
                                :options="bedrooms"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Bathrooms
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="bathrooms"
                                v-model="criteria_breadcrumbs"
                                name="bathrooms"
                                :options="bathrooms"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
                <li class="nav-item has-treeview">
                    <a href="#" class="nav-link">
                        <p>
                            Listing Status
                            <i class="right fas fa-angle-left"></i>
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item mb-1 ml-2">
                            <b-form-checkbox-group
                                @change="submit()"
                                id="status"
                                v-model="criteria_breadcrumbs"
                                name="status"
                                :options="status"
                                unchecked-value=""
                                stacked>
                            </b-form-checkbox-group>
                            <hr>
                        </li>
                    </ul>
                </li>
            </b-form>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'filters',

    created() {
        this.criteria_breadcrumbs = this.criteria;
        this.getNeighborhoods();
        this.getStyles();
    },
    data() {
        return {
            price_range: 0,
            criteria_breadcrumbs: [],
            styles: [],
            neighborhoods: [],
            property_types: [
                {text: "Single Family", value: {text: "Single Family", value: "pt-SF", label: "Single Family"}, label: "Single Family"},
                {text: "Condominum", value: {text: "Condominum", value: "pt-CO", label: "Condominums"}, label: "Condominums"},
                {text: "MultiFamily", value: {text: "MultiFamily", value: "pt-MF", label: "Multi-Family Homes"}, label: "Multi-Family Homes"},
                {text: "Land", value: {text: "Land", value: "pt-RL", label: "Residential Land"}, label: "Residential Land"}
            ],
            price_ranges: [
                {text: "100,000 and less", value: {text: "100,000 and less", value: "pr-0", "label": "100,000 and less"}, "label": "100,000 and less"},
                {text: "1 - 200,000", value: {text: "1 - 200,000", value: "pr-1", "label": "1 - 200,000"}, "label": "1 - 200,000"},
                {text: "2 - 300,000", value: {text: "2 - 300,000", value: "pr-2", "label": "2 - 300,000"}, "label": "2 - 300,000"},
                {text: "3 - 400,000", value: {text: "3 - 400,000", value: "pr-3", "label": "3 - 400,000"}, "label": "3 - 400,000"},
                {text: "4 - 500,000", value: {text: "4 - 500,000", value: "pr-4", "label": "4 - 500,000"}, "label": "4 - 500,000"},
                {text: "500,000+", value: {text: "500,000+", value: "pr-5", "label": "500,000 and more"}, "label": "500,000 and more"}
            ],
            bedrooms: [
                {text: "1 Bed", value: {text: "1 Bed", value: "bd-1", "label": "1 Bed"}, "label": "1 Bed"},
                {text: "2 Beds", value: {text: "2 Beds", value: "bd-2", "label": "2 Bed"}, "label": "2 Bed"},
                {text: "3 Beds", value: {text: "3 Beds", value: "bd-3", "label": "3 Bed"}, "label": "3 Bed"},
                {text: "4 Beds", value: {text: "4 Beds", value: "bd-4", "label": "4 Bed"}, "label": "4 Bed"},
                {text: "5 Beds", value: {text: "5 Beds", value: "bd-5", "label": "5 Bed"}, "label": "5 Bed"},
            ],
            bathrooms: [
                {text: "1 Bath", value: {text: "1 Bath", value: "br-1", "label": "1 Bath"}, "label": "1 Bath"},
                {text: "2 Bath", value: {text: "2 Bath", value: "br-2", "label": "2 Bath"}, "label": "2 Bath"},
                {text: "3 Bath", value: {text: "3 Bath", value: "br-3", "label": "3 Bath"}, "label": "3 Bath"},
                {text: "4 Bath", value: {text: "4 Bath", value: "br-4", "label": "4 Bath"}, "label": "4 Bath"},
                {text: "5 Bath", value: {text: "5 Bath", value: "br-5", "label": "5 Bath"}, "label": "5 Bath"},
            ],
            status: [
                {text: "Active", value: {text: "Active", value: "ls-1", "label": "Active Status"}, "label": "Active Status"},
                {text: "Active and Pending", value: {text: "Active and Pending", value: "ls-2", "label": "Active and Pending Status"}, "label": "Active and Pending Status"},
                {text: "Pending", value: {text: "Pending", value: "ls-3", "label": "Pending Status"}, "label": "Pending Status"},
                {text: "Closed", value: {text: "Closed", value: "ls-4", "label": "Closed Status"}, "label": "Closed Status"},
                {text: "Any Status", value: {text: "Any Status", value: "ls-5", "label": "All Listing Statuses"}, "label": "All Listing Statuses"},
            ]
        }
    },
    methods: {
        addCriteria(criterion) {
            let _self = this;
            _self.$eventHub.$emit('criteria::added', criterion);
        },
        clear() {
            this.criteria = this.criteria_breadcrumbs = [];
            this.getListings();
        },
        removeCriteria(criterion) {
            let _self = this;
            _self.$eventHub.$emit('criteria::removed', criterion);
        },
        addPriceToCriteria() {
            let _self = this;
            let text = _self.price_range;
            //get last 2 numbers e.g.  35, 10 for 1 mil
            let value = "pr-" + String(_self.price_range).slice(0, 2);

            if (_self.price_range.length > 6) {
                value += 0;
            }

            if (typeof _self.criteria_breadcrumbs == 'undefined') {
                _self.criteria_breadcrumbs = [];
            }

            let price_criterion = {text: text, value: value, "label": "Up to " + this.$options.filters.toCurrency(text)};

            for (var i = 0; i < _self.criteria_breadcrumbs.length; i++) {
                if (_self.criteria_breadcrumbs[i].value.includes("pr-")) {
                    _self.criteria_breadcrumbs.splice(i, 1);
                }
            }

            _self.criteria_breadcrumbs.push(price_criterion);

            _self.$eventHub.$emit('criteria::submit', _self.criteria_breadcrumbs);
        },
        submit() {
            let _self = this;
            _self.$eventHub.$emit('criteria::submit',this.criteria_breadcrumbs);
        },
        getNeighborhoods() {
            let _self = this;
            let promise = axios.get('/api/neighborhoods?type=mobile');

            return promise.then((response) => {

                _self.neighborhoods = $.map(response.data, function (dataItem) {
                    return dataItem;
                });
            });
        },
        getStyles() {
            let _self = this;
            let promise = axios.get('/api/styles?type=mobile');

            return promise.then((response) => {

                _self.styles = $.map(response.data, function (dataItem) {
                    return dataItem;
                });
            });
        },
    }
}

</script>

<style>

.container .dropdown .dropdown-menu a:hover {
    color: #fff;
    background-color: darkgrey;
    border-color: #fff;
}

.limit {
    max-height:300px;
    overflow:scroll;
}
</style>
